<template>
  <div class="chatRoomItem">
    <div class="roomOwnerPic" >
      <img :src="roomInfo.opener_img" alt="">
      <span class="imgLine" :class="roomInfo.room_class"></span>
    </div>
    <div class="roomInfoArea">
      <div class="roomTitle" @click="enterRoom(roomInfo.room_uid, roomInfo.rank)" >{{roomInfo.name}}</div>
      <div class="roomUserCount">
        <span v-if="roomInfo.is_sec === 'Y'" class="secret_room"></span>
        <span>{{roomInfo.cur_user}}</span>/{{roomInfo.max_user}} 명
      </div>
      <div class="roomOwnerName icon" :rel="roomInfo.opener_id" v-html="roomInfo.opener_level_icon"></div>
      <div class="roomOwnerName" :rel="roomInfo.opener_id" @click="showContextMenu">
        <span :rel="roomInfo.opener_id">{{roomInfo.opener_name}}</span>
      </div>
    </div>
    <div class="roomCreatedTime" v-html="roomInfo.time"></div>
  </div>
  <!-- API가 적용되면 사용이 가능한 TEMPLETE 입니다. (무기한 적용 연기)
    <div class="chatRoomItem">
    <div class="roomOwnerPic" >
      <img :src="roomInfo.hasProfileImage ? roomInfo.userProfileImageUrl:'/img/default/no_profile_m.png'" alt="">
      <span class="imgLine" :class="roomInfo.new? 'new':''" :class="roomInfo.popular? 'hot':''" :class="roomInfo.free? 'free':''"></span>
    </div>
    <div class="roomInfoArea">
      <div class="roomTitle" @click="enterRoom(roomInfo.id, roomInfo.rank)" >{{roomInfo.title}}</div>
      <div class="roomUserCount">
        <span v-if="roomInfo.private" class="secret_room"></span>
        <span>{{roomInfo.currentUserCount}}</span>/{{roomInfo.maxUserCount}} 명
      </div>
      <div class="roomOwnerName icon" :rel="roomInfo.userId">
        <img :src="'/img/lv/23/m' + roomInfo.userGrade + '.png?v=20140417'">
      </div>
      <div class="roomOwnerName" :rel="roomInfo.userId" @click="showContextMenu">
        <span :rel="roomInfo.userId">{{roomInfo.userNick}}</span>
      </div>
    </div>
    <div class="roomCreatedTime">{{ getTimeago(roomInfo.createdDateTime) }}</div>
  </div>-->
</template>

<script>
import { enterChatRoom, showContextMenu, getTimeago } from '../util'

export default {
  props: [
    'roomInfo'
  ],
  methods: {
    'enterRoom': enterChatRoom,
    'showContextMenu': showContextMenu,
    'getTimeago': getTimeago
  }
}
</script>

<style lang="scss">
.chatRoomItem {
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 8px;
  font-size: 12px;
  vertical-align: sub;
  position: relative;
  border-top: 1px solid #E5E5E5;
  &:after {
    content:"";
    display:block;
    clear:both;
  }
  .roomOwnerPic {
    float: left;
    img {
      top: 8px;
      left: 8px;
      width: 43px;
      height: 43px;
    }
    .imgLine {
      position: absolute;
      top: 8px;
      left: 8px;
      width: 43px;
      height: 43px;
      background: url(/nlivechat/img/sp_chat.png) no-repeat -40px -240px;
      &.free {
        background-position: -90px -240px;
      }
      &.hot {
        background-position: -140px -240px;
      }
      &.new {
        background-position: -190px -240px;
      }
    }
  }
  .roomInfoArea {
    float: left;
    padding-left: 10px;

    .roomTitle {
      cursor: pointer;
      font-size: 13px;
      max-width: 200px;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-family:'맑은 고딕','굴림';
      font-weight: bold;
      color: rgb(0, 0, 0);
      overflow: hidden;
      margin-bottom: 5px;
    }
    .roomUserCount {
      float: left;
      padding-top: 5px;
      margin-right: 13px;
      span {
        color: #D45328;
        font-weight: 600;
      }
      .secret_room {
        float: left;
        margin: 2px 5px 0 0;
        width: 10px;
        height: 13px;
        background: url(/nlivechat/img/sp_room_nw2.png) no-repeat -90px 0;
        text-indent: -9999px;
      }
    }
    .roomOwnerName {
      float: left;
      cursor: pointer;
      margin-right: 5px;
      img {
        display: inline-block;
      }
      span {
        display: inline-block;
        padding-top: 5px;
      }
    }
  }
  .roomCreatedTime {
    float: left;
    width: 40px;
    position: absolute;
    top: 8px;
    right: 8px;
    height: 14px;
    line-height: 14px;
    font-size: 11px;
    font-family: Dotum;
    color: rgb(167, 163, 162);
    & em {
      font-style: normal;
    }
  }
}
</style>



// WEBPACK FOOTER //
// chat-room.vue?e2a7617a